/**
 * @param {Error} error
 * @returns {string}
 */
export default function deriveBackendErrorMessage(error) {
    const response = error?.response;

    if (!response) {
        return 'Unknown error (no response)';
    }

    const code = (
        response?.data?.code
        ?? response.status
        ?? '???'
    );

    const message = (
        response?.data?.message
        ?? (
            (!response) ? 'Unknown error (no response)'
            : (!response.data) ? 'Unknown error (no data)'
            : 'Unknown error (no error info)'
        )
    );

    return `${code}: ${message}`;
}